/**
 * Builds the `topic_analysis_persona_review_opened` event fired when a
 * specialist's AI Critique accordion row becomes visible — whether by
 * clicking the row itself or a `ReviewerChips` chip. Fires only on the
 * transition to open, never on collapse — see AICritiqueResults.tsx.
 */

import { getSessionId } from "./session";
import type { PersonaReviewSource, TopicAnalysisPersonaReviewOpenedEvent } from "./types";

export const buildTopicAnalysisPersonaReviewOpenedEvent = (
  personaId: number,
  source: PersonaReviewSource,
  projectId: number | null,
): TopicAnalysisPersonaReviewOpenedEvent => ({
  name: "topic_analysis_persona_review_opened",
  occurred_at: new Date().toISOString(),
  session_id: getSessionId(),
  hub_id: null,
  project_id: projectId,
  properties: { persona_id: personaId, source },
});
